export default __webpack_public_path__ + "static/media/farmers3.a8ad5830.jpg";